module.exports = __webpack_public_path__ + "img/flag.2837a08a.gif";